// Leitura de ficheiros .ids. A lógica vive no motor partilhado
// (packages/ids), consumido também pelo servidor MCP: um só sítio onde a
// norma está implementada, para as duas superfícies não poderem chegar a
// vereditos diferentes sobre o mesmo ficheiro.
//
// Aqui fica apenas a ligação à plataforma: as mensagens de erro em
// português. O XML é lido pelo leitor do próprio pacote e não pelo
// DOMParser do browser, para o comportamento ser o mesmo que a suite de
// conformidade mede.

import {
  parseIds as parseIdsCore,
  MESSAGES_PT,
  type ParseIdsOptions,
  type IdsFile,
} from '@vn2r/ids'

export { countUnsupported } from '@vn2r/ids'

export type {
  Cardinality,
  IdsValue,
  EntityFacet,
  AttributeFacet,
  PropertyFacet,
  ClassificationFacet,
  MaterialFacet,
  PartOfFacet,
  UnsupportedFacet,
  Facet,
  IdsSpec,
  IdsInfo,
  IdsFile,
} from '@vn2r/ids'

/** Lê um ficheiro .ids. Erros de validação vêm em português. */
export function parseIds(xml: string, options: ParseIdsOptions = {}): IdsFile {
  return parseIdsCore(xml, { messages: MESSAGES_PT, ...options })
}
